export default "__VITE_ASSET__vKiDQv4E__"